import { render, staticRenderFns } from "./InfoNewsAndEvents.vue?vue&type=template&id=08c5fd4e&scoped=true"
import script from "./InfoNewsAndEvents.vue?vue&type=script&lang=js"
export * from "./InfoNewsAndEvents.vue?vue&type=script&lang=js"
import style0 from "./InfoNewsAndEvents.vue?vue&type=style&index=0&id=08c5fd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5fd4e",
  null
  
)

export default component.exports